import { useTheme } from '@mui/material/styles'
import { Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'

export const Footer = () => {
	const theme = useTheme()

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				paddingTop: '0.25rem',
				position: 'fixed',
				bottom: 0,
				width: '100%',
				paddingBottom: '0.25rem',
				backgroundColor: theme.palette.primary.main,
				color: 'white'
			}}
		>
			<Grid container spacing={2} justifyContent="center" alignItems="center">
				{/* <h4>Contáctanos</h4> */}

				<Grid container justifyContent="center" alignItems="center" direction="row">
					<Box width={35} marginX={4} className="scale-up-hover">
						<a href="https://www.icta.gob.gt/">
							<img src="assets\globe.png" alt="Website" width="100%" />
						</a>
					</Box>

					<Box width={40} marginX={4} className="scale-up-hover">
						<a href="mailto:cristianfrancisco85@gmail.com">
							<img src="assets\email.png" alt="Email" width="100%" />
						</a>
					</Box>
				</Grid>
			</Grid>
		</Box>
	)
}
